module.exports = __webpack_public_path__ + "static/pic24-0f07e775a081b81e2ab9549dcfa39dbf.png";